exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h4 {\r\n    font-size: 16px;\r\n    background: #dee7ff !important;\r\n    height: 40px;\r\n    line-height: 40px;\r\n    margin-bottom: 0;\r\n    width: 100%;\r\n    padding-left: 15px;\r\n}\r\n\r\n.group-box {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-align: end;\r\n        -ms-flex-align: end;\r\n            align-items: flex-end;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Biziclick/bizisystem/src/app/main/frames/organization-parameter/organization-parameter.component.css
// module id = ../../../../../src/app/main/frames/organization-parameter/organization-parameter.component.css
// module chunks = main